<template>
    <div class="grid grid-cols-2 gap-4" data-cy="list_campaign_list">
        <CampaignItem
            v-for="(campaign) in states.campaigns"
            :key="campaign.id"
            :campaign="campaign"
            :data-cy="`card_campaign_list_item_${campaign.id}`"
        ></CampaignItem>

        <div v-if="states.isLoaded && !states.isHaveItem" data-cy="text_campaign_list_not_found">Not Found</div>
    </div>
</template>
<script>
//component
import CampaignItem from "./CampaignItem.vue";
//service
import useCampaignListComposable from "@/composables/CampaignListComposable";

export default {
    name: "CampaignList",
    components: {
        CampaignItem,
    },
    props: {
        modalController: { type: Object },
    },
    emits: ["onLoaded", "onError", "onLoadingChange"],
    data: function () {
        return {

        };
    },
    setup: function (props, { emit }) {
        const { states, getList, loadMore } = useCampaignListComposable({
            getOnMounted: true
        }, emit)

        return {
            states,
            getList,
            loadMore
        }
    },
    methods: {
        reinitList: function () {
            this.campaigns = [];
            this.getList();
        },
        toggleLoader: function (val) {
            if (val) {
                this.modalController.loadingModal.show()
            } else {
                this.modalController.loadingModal.hide()
            }
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
